<template>
  <div class="tab-close">
    <!-- TODO: 标签页过多时  需要控制dropdown高度，添加滚动条 -->
    <a-dropdown v-model="visible" :trigger="['click']" overlayClassName="tab-close-dropdown-wrapper" :getPopupContainer="getPopupContainer">
      <span class="arrow-left">
        <sass-icon
          type="hi-duoyeqian"
          style="font-size: 26px;"
        />
        <span class="tag-count">{{tabs.length || ''}}</span>
      </span>
      <a-menu class="tab-close-menu" slot="overlay" style="min-width: 200px;" @click="onClick">
        <a-menu-item v-for="tab in tabs" :key="tab.path" :class="[{ 'drag-menu-item' : tab.title !== '首页' }, { 'activePath' : activePath === tab.path }]">
          <router-link :to="{path: tab.path, query: tab.query}" draggable="true" style="width:100%;">{{ tab.title }}</router-link>
          <div v-show="tab.title !== '首页'" @click.stop="onClose(tab)">
            <sass-icon
              type="hi-guanbidanchuangdanchuang"
              class="tabs-close"
            />
          </div>
        </a-menu-item>
        <a-menu-divider />
        <a-menu-item key="all" class="ant-dropdown-menu-item-last">
          <div style="display: inline-block; margin-right: 6px;"><sass-icon
            type="hi-guanbisuoyouye"
            class="tabs-close"
            style="font-size: 16px;"
          /></div>关闭全部</a-menu-item>
        <a-menu-item key="other" class="ant-dropdown-menu-item-last">
          <div style="display: inline-block; margin-right: 6px;"><sass-icon
            type="hi-guanbisuoyouye"
            class="tabs-close"
            style="font-size: 16px;"
          /></div>关闭其他</a-menu-item>
      </a-menu>
    </a-dropdown>
  </div>
</template>

<script>
import CommonIcon from '@/components/common-icon'
import Sortable from 'sortablejs'

export default {
  components: {
    CommonIcon
  },
  data () {
    return {
      getPopupContainer: () => {
        return document.querySelector('.tabs-sum-list')
      },
      visible: false
    }
  },
  watch: {
    visible (flag) {
      if (flag && !this.sortable) {
        this.initDrag()
      }
    }
  },
  methods: {
    onClick(e) {
      const path = e.key
      if (!path) return
      if (path === 'all') {
        this.$store.dispatch('closeAll')
      } else if (path === 'other') {
        this.$store.dispatch('closeOther')
      } else {
        // this.$router.push({ path: path })
      }
      if (path === 'all' || path === 'other') {
        this.visible = false
      }
    },
    // 点击关闭
    onClose(path) {
      if (!path) return
      this.$store.dispatch('removeTab', path)
    },
    initDrag () {
      const that = this
      this.$nextTick(() => {
        const el = document.querySelector('.tabs-sum-list .tab-close-menu')
        that.sortable = Sortable.create(el, {
          handle: '.drag-menu-item',
          draggable: '.drag-menu-item',
          animation: 150,
          ignore: 'img',
          onEnd: ({ newIndex, oldIndex }) => {
            const listData = this.$store.state.tabs.tabs
            listData.splice(newIndex, 0, listData.splice(oldIndex, 1)[0])
            const newArray = listData.slice(0)
            that.$store.commit('setTabs', newArray)
          }
        })
      })
    }
  },
  computed: {
    tabs() {
      let tabs = this.$store.state.tabs.tabs
      if (tabs?.length < 1) {
        tabs = [{
          path: '/home',
          title: '首页'
        }]
      }
      return tabs
    },
    activePath() {
      const activePath = this.$store.state.tabs.activePath
      return activePath || ''
    }
  }
}
</script>

<style lang="less">
.tab-close {
  position: relative;
  height: 26px;
  line-height: 22px;
  .arrow-left {
    display: block;
    position: relative;
    transition: .3s;
    .tag-count {
      position: absolute;
      top: 3px;
      left: 0;
      width: 22px;
      font-size: 9px;
      text-align: center;
      color: #00a497;
    }
  }
  .ant-dropdown-open {
    transform: scale(1.2);
  }
  &::after {
    position: absolute;
    top: 8px;
    right: -12px;
    width: 1px;
    height: 12px;
    background: #fff;
    opacity: .3;
    content: '';
  }
  &:hover {
    cursor: pointer;
  }
}
.tab-close-menu {
  padding: 8px 0;
  padding-top: 8px !important;
  .ant-dropdown-menu-item-divider {
    margin: 8px 0;
  }
  .ant-dropdown-menu-item {
    display: flex;
    margin: 0 0 4px;
    padding: 0 12px;
    height: 28px;
    font-size: 12px;
    line-height: 28px;
    justify-content: space-between;
    &:hover {
      color: #00a497;
      background: #f3f5f7;
    }
    span {
      flex: 1;
    }
    div {
      display: none;
    }
    &:hover {
      div {
        display: inline-block;
        color: rgba(51, 51, 51, .85);
      }
    }
    &.ant-dropdown-menu-item-last {
      justify-content: flex-start;
      &:hover {
        div {
          display: inline-block;
          color: #00a497;
        }
      }
    }
    &.activePath {
      color: #00a497;
      a {
        color: #00a497;
      }
    }
  }
  .drag-menu-item {
    cursor: pointer;
  }
  .drag-menu-item:active {
    cursor: -webkit-grabbing;
    >div {
      cursor: pointer;
    }
  }
}
.tab-close-dropdown-wrapper {
  height: 450px;
  .tab-close-menu {
    overflow-y: auto;
    max-height: 450px;
  }
}
</style>
